import React, { Component } from 'react';

export default class ReportingTopBar extends Component {

    constructor(props) {
        super(props);

        this.state = {

        }
    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    render() {
        let outerStyle = {};

        if (!this.props.isScrollTop) {
            outerStyle.boxShadow = '0 1px 2px rgba(0, 0, 0, 0.16), 0 3px 3px rgba(0, 0, 0, 0.23)';
        }

        return (
            <div className="reporting-top-bar-outer">
                <div className="reporting-top-bar-normal-container">
                    {
                        this.props.mode === "reportList" ?
                            <div className="reporting-top-bar-menu-button material-icons" onClick={this.props.toggleNav}>{"menu"}</div>
                            :
                            <div className="reporting-top-bar-menu-button material-icons" onClick={this.props.back}>{"arrow_back"}</div>
                    }
                    <div className="reporting-top-bar-selector-container">
                        <div className="reporting-top-bar-title">{"Reporting"}</div>
                    </div>
                </div>
            </div>
        );
    }
}
